import React, { useEffect, useState } from "react";
import website from "../website/data";
import "./css/HomePopup.css";

const HomePopup = ({ pimg, popupImageStatus, popupImageLink }) => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			setShow(true);
		}, 1000);
	}, []);

	const handleClosePopup = (e) => {
		e.stopPropagation();
		setShow(false);
		localStorage.setItem("popup", "no");
	};

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = "Are you sure you want quit?";
			localStorage.setItem("popup", "yes");
		};
		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

	return (
		<>
			{localStorage.getItem("popup") === "yes" &&
				show &&
				popupImageStatus === "yes" && (
					<div
						className="d-block d-lg-none blackscreen"
						onClick={handleClosePopup}
					></div>
				)}
			{localStorage.getItem("popup") === "yes" &&
				show &&
				popupImageStatus === "yes" && (
					<div className={`d-block d-lg-none home-popup ${show && "active"}`}>
						<img
							src={`${website.link}/${pimg}`}
							alt=""
							onClick={() => window.open(popupImageLink)}
						/>
						<button className="" onClick={handleClosePopup}>
							Close
						</button>
					</div>
				)}
		</>
	);
};

export default HomePopup;
